import React from 'react';
import { useUser } from '../../hooks/useUser';
import { isInternal } from '../../utils';
import IdPill from '../IdPill/IdPill';

interface Props {
  userid?: number | string | null;
  className?: string;
}

export function ExpertIdPill({ userid, className }: Props) {
  const { role } = useUser();
  if (!isInternal(role)) return null;
  return <IdPill value={userid} className={className} />;
}

export default ExpertIdPill;
